// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__2wlSv","accordion-title":"styles_accordion-title__Lbu91","accordion-content":"styles_accordion-content__2ptEu","open":"styles_open__1G5DS"};